import { Sun, Users, Plus, Activity, LayoutGrid, CircleUser } from "lucide-react";
import { useProto } from "./ProtoContext";
import { CHURCH, leaderName } from "./data";
import { Avatar } from "./ui";
import { cn } from "@/lib/utils";

const items = (role) => [
  { id: "today", label: "Today", Icon: Sun },
  { id: "people", label: role === "pastor" ? "People" : "My People", Icon: Users },
  role === "pastor" ? { id: "overview", label: "Overview", Icon: LayoutGrid } : { id: "activity", label: "Activity", Icon: Activity },
  { id: "me", label: "Me", Icon: CircleUser },
];

const useNav = () => {
  const { screen, go, soon } = useProto();
  const active = screen === "person" ? "people" : screen;
  const tap = (id) => (["activity", "me"].includes(id) ? soon(id === "me" ? "Me" : "Activity") : go(id));
  return { active, tap };
};

export const BottomNav = () => {
  const { role, openLog } = useProto();
  const { active, tap } = useNav();
  const [a, b, c, d] = items(role);
  const Tab = ({ it }) => (
    <button onClick={() => tap(it.id)} className={cn("flex-1 flex flex-col items-center gap-1 pt-2 text-[12px] font-medium transition-colors", active === it.id ? "text-ink" : "text-ink-faint")} data-testid={`bottom-nav-${it.id}`}>
      <it.Icon size={24} strokeWidth={active === it.id ? 2.2 : 1.7} />{it.label}
    </button>
  );
  return (
    <nav className="absolute bottom-0 inset-x-0 z-30 bg-[color:var(--paper-glass)] backdrop-blur-xl border-t border-line pb-6 pt-1 flex items-start" data-testid="bottom-nav">
      <Tab it={a} /><Tab it={b} />
      <div className="flex-1 flex justify-center">
        <button onClick={() => openLog(null)} aria-label="Add care" className="-mt-5 h-16 w-16 rounded-full bg-brand text-white shadow-lift flex items-center justify-center active:scale-95 transition-transform" data-testid="bottom-nav-add-care"><Plus size={28} /></button>
      </div>
      <Tab it={c} /><Tab it={d} />
    </nav>
  );
};

export const Sidebar = () => {
  const { role, me, openLog } = useProto();
  const { active, tap } = useNav();
  return (
    <aside className="w-[264px] shrink-0 border-r border-line bg-paper flex flex-col px-5 py-7" data-testid="desktop-sidebar">
      <p className="t-title px-3">Care</p>
      <p className="text-sm text-ink-faint px-3 mt-0.5">{CHURCH.name}</p>
      <button onClick={() => openLog(null)} className="btn btn-primary mt-8" data-testid="sidebar-add-care"><Plus size={18} /> Add care</button>
      <nav className="mt-8 flex flex-col gap-1">
        {items(role).filter((i) => i.id !== "me").map((it) => (
          <button key={it.id} onClick={() => tap(it.id)} className={cn("h-12 px-3 rounded-[12px] flex items-center gap-3 text-[16px] font-medium transition-colors", active === it.id ? "bg-sunk text-ink" : "text-ink-soft hover:bg-sunk/60 hover:text-ink")} data-testid={`sidebar-nav-${it.id}`}>
            <it.Icon size={20} />{it.label}
          </button>
        ))}
      </nav>
      <div className="mt-auto flex items-center gap-3 px-2">
        <Avatar person={me} size={40} />
        <div className="min-w-0"><p className="text-ink font-medium leading-tight truncate">{leaderName(me.id)}</p><p className="text-sm text-ink-faint">{me.title}</p></div>
      </div>
    </aside>
  );
};
